import { RadialBarChart, RadialBar, Legend } from "recharts";
import "./EngineDashboard.css";
import React, { useState, useEffect } from "react";
import {
  Button, Card, CardBody, CardHeader, Col, Container,
  Modal, ModalBody, ModalFooter, Row, ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import CustomGauge from "./RadialChart";
import IndicatorsModal from "./IndicatorsModal";
import GaugesModal from "./GaugeModal";
import MachineModal from "./MachineModal";
import axios from "axios";
import DownAlarm2Modal from "./DownAlarm2";
import DownAlarm1Modal from "./DownAlarm1";
import DownAlarm3Modal from "./DownAlarm3";
import DownAlarm4Modal from "./DownAlarm4";
import ExhaustSection from "./Exhaust";
import PageGrid from "../../components/GridLayout/PageGrid";

const gauges = [
  { name: "Power",     value: 959,  unit: "kW", max: 2000 },
  { name: "Amperage",  value: 1388, unit: "A",  max: 2000 },
  { name: "Voltage",   value: 454,  unit: "V",  max: 1000 },
  { name: "Frequency", value: 59.9, unit: "Hz", max: 100  },
];

const Machine = () => {
  const [editMode,         setEditMode]         = useState(false);
  const [indicatorsModal,  setIndicatorsModal]  = useState(false);
  const [gaugesModal,      setGaugesModal]      = useState(false);
  const [downAlarm1Modal,  setDownAlarm1Modal]  = useState(false);
  const [downAlarm2Modal,  setDownAlarm2Modal]  = useState(false);
  const [downAlarm3Modal,  setDownAlarm3Modal]  = useState(false);
  const [downAlarm4Modal,  setDownAlarm4Modal]  = useState(false);
  const [currentType,      setCurrentType]      = useState(null);
  const openModal  = (type) => setCurrentType(type);
  const closeModal = ()     => setCurrentType(null);
  const role = localStorage.getItem("role");

  const [indicatorsData, setIndicatorsData] = useState([]);
  const [gaugesData,     setGaugesData]     = useState([]);
  const [downAlarm1Data, setDownAlarm1Data] = useState([]);
  const [downAlarm2Data, setDownAlarm2Data] = useState([]);
  const [downAlarm3Data, setDownAlarm3Data] = useState([]);
  const [downAlarm4Data, setDownAlarm4Data] = useState([]);

  const [alarms1,  setAlarms1]  = useState([]);
  const [alarms2,  setAlarms2]  = useState([]);
  const [alarms3,  setAlarms3]  = useState([]);
  const [alarms4,  setAlarms4]  = useState([]);
  const [alarms5,  setAlarms5]  = useState([]);
  const [alarms6,  setAlarms6]  = useState([]);
  const [alarms7,  setAlarms7]  = useState([]);
  const [alarms8,  setAlarms8]  = useState([]);
  const [alarms9,  setAlarms9]  = useState([]);
  const [alarms10, setAlarms10] = useState([]);
  const [alarms11, setAlarms11] = useState([]);
  const [alarms12, setAlarms12] = useState([]);
  const [alarms13, setAlarms13] = useState([]);
  const [alarms14, setAlarms14] = useState([]);
  const [alarms15, setAlarms15] = useState([]);
  const [alarms16, setAlarms16] = useState([]);
  const [alarms17, setAlarms17] = useState([]);
  const [alarms18, setAlarms18] = useState([]);
  const [alarms19, setAlarms19] = useState([]);

  const [modal_list,     setmodal_list]     = useState(false);
  const [editedMachine,  setEditedMachine]  = useState(null);
  const [responseMessage,setResponseMessage]= useState("");
  const [isLoading,      setIsLoading]      = useState(false);
  const authToken = localStorage.getItem("access");

  const [formData, setFormData] = useState({
    parameters: [{ name: "", tag: "", type: "bool", unit: "", value: "", status: false }],
  });

  const fetchAlarm = async () => {
    try {
      setIsLoading(true);
      const responses = await Promise.all(
        Array.from({ length: 19 }, (_, i) =>
          axios.get(`https://api.hanoch.in/equipment/alarms/?type=${i + 1}`)
        )
      );
      const setters = [setAlarms1,setAlarms2,setAlarms3,setAlarms4,setAlarms5,setAlarms6,setAlarms7,
        setAlarms8,setAlarms9,setAlarms10,setAlarms11,setAlarms12,setAlarms13,setAlarms14,
        setAlarms15,setAlarms16,setAlarms17,setAlarms18,setAlarms19];
      responses.forEach((r, i) => setters[i](r));
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("access");
        localStorage.removeItem("role");
      } else { console.error("Error fetching alarms:", error); }
    } finally { setIsLoading(false); }
  };

  useEffect(() => { fetchAlarm(); }, []);

  const handleParamChange = (index, field, value) => {
    const updated = [...formData.parameters];
    updated[index][field] = value;
    setFormData({ ...formData, parameters: updated });
  };
  const handleAddRow = () => setFormData({ ...formData, parameters: [...formData.parameters, { name:"",tag:"",type:"bool",unit:"",value:"",status:false }] });
  const handleDeleteRow = (index) => setFormData({ ...formData, parameters: formData.parameters.filter((_,i)=>i!==index) });

  /* ── Ship Header widget ─────────────────────────────────────────── */
  const ShipHeader = (
    <Card className="h-100 mb-0">
      <CardHeader className="custom-card-header">
        <Row>
          <div className="col-lg-4 header-left">
            <div className="time-box"><div>UTC:03:36:16</div><div>LOCAL:05:34:16</div></div>
            <div className="ship-info d-flex align-items-center">
              <div><h6 className="ship-title mb-0">CLEMENS SCHULTE</h6><p className="ship-sub mb-0">IMO 9665671 BSM</p></div>
            </div>
          </div>
          <div className="col-lg-8 header-right">
            <div className="menu d-flex justify-content-between me-3">
              {["Dashboard","AMS","Alerts"].map(btn=><button key={btn} className="menu-btn mx-2">{btn}</button>)}
              <button className="menu-btn"><Link to="/alarms">Alarms</Link></button>
              {["Voyage","CCTV","Status","Master","User"].map(btn=><button key={btn} className="menu-btn">{btn}</button>)}
              <div className="counter red1">10</div>
              <div className="counter yellow1">19</div>
              {role === "admin" && (
                <label className="switch">
                  <input type="checkbox" checked={editMode} onChange={()=>setEditMode(!editMode)} />
                  <span className="slider"></span>
                </label>
              )}
            </div>
          </div>
        </Row>
      </CardHeader>
    </Card>
  );

  /* ── Indicators widget ──────────────────────────────────────────── */
  const IndicatorsPanel = (
    <Card className="h-100 mb-0">
      <CardBody>
        <Row>
          <Col lg={6}>
            <div className="indicators">
              <Row className="mb-2">
                <Col xs={6}><div className="border p-2 bg-secondary text-white">G/E COMMON</div></Col>
                <Col xs={6}><div className="border p-2 bg-secondary text-white">GENERATORS</div></Col>
              </Row>
              <Row className="mb-2">
                {[1,2,3,4].map(n=><Col key={n}><Button>{n}</Button></Col>)}
              </Row>
              {editMode && (
                <button className="btn btn-primary" style={{borderRadius:"6px",width:"28px",height:"28px",padding:"0",fontSize:"18px"}} onClick={()=>setmodal_list(true)}>
                  <i className="ri-add-line" />
                </button>
              )}
              {isLoading
                ? <div className="text-center mt-3"><div className="spinner-border text-primary"/><p className="mt-2">Loading alarms...</p></div>
                : alarms1.map((item,i)=>(
                  <div key={i} className="indicator-row">
                    <span>{item.description}</span>
                    <span className={`status-light ${item.response_color_one?.toLowerCase()||"grey"}`} />
                  </div>
                ))
              }
            </div>
          </Col>
          <Col lg={6}>
            <div className="indicators">
              {editMode && (
                <button className="btn btn-primary" style={{borderRadius:"6px",width:"28px",height:"28px",padding:"0",fontSize:"18px"}} onClick={()=>setIndicatorsModal(true)}>
                  <i className="ri-add-line" />
                </button>
              )}
              {alarms2.map((item,i)=>(
                <div key={i} className="indicator-row">
                  <span className="indicator-label">{item.description}</span>
                  <span className="indicator-value">{item.value}</span>
                  <span className="indicator-unit">{item.unit}</span>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );

  /* ── Gauges widget ──────────────────────────────────────────────── */
  const GaugesPanel = (
    <Card className="h-100 mb-0">
      <CardBody>
        <Row className="mb-3">
          {gauges.map((g,i)=>(
            <Col lg={3} md={6} sm={6} xs={12} key={i}>
              <CustomGauge value={g.value} max={g.max} label={g.value} unit={g.unit} />
              <div className="text-center gname p-2">{g.name}</div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col lg={4}>
            <div className="exhaust-left">
              {editMode && (
                <button className="btn btn-primary" style={{borderRadius:"6px",width:"28px",height:"28px",padding:"0",fontSize:"18px"}} onClick={()=>setGaugesModal(true)}>
                  <i className="ri-add-line" />
                </button>
              )}
              {alarms3.map((item,i)=>(
                <div key={i} className="indicator-row">
                  <span>{item.description}</span><span className="value-box">412</span><span>°C</span>
                </div>
              ))}
            </div>
          </Col>
          <Col lg={8}>
            <div className="exhaust-right">
              <div className="title">EXH. GAS TEMP [°C]</div>
              <div className="title">EXH. GAS DEVIATION</div>
              <div className="exhaust-grid">
                {["NO 1","NO 2","NO 3","NO 4","NO 5","NO 6"].map(n=><div key={n} className="header-box">{n}</div>)}
                {[8,9,10,11,12,13,14,15,16,17,18,19].map(type=>(
                  <div key={type} className="value-box">
                    {editMode
                      ? <span className="edit-dot" onClick={()=>openModal(type)}><i className="ri-add-line" /></span>
                      : ([alarms8,alarms9,alarms10,alarms11,alarms12,alarms13,alarms14,alarms15,alarms16,alarms17,alarms18,alarms19][type-8]||[]).map((item,i)=><div key={i}>{item.min_value||405}</div>)
                    }
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col><div className="engine-section"><img src="/asset/eimm.png" alt="Engine" className="engine-img container-fluid"/></div></Col>
        </Row>
      </CardBody>
    </Card>
  );

  /* ── Down Alarms widget ─────────────────────────────────────────── */
  const DownAlarmsPanel = (
    <Card className="h-100 mb-0">
      <CardBody>
        <Row>
          {[
            {alarms:alarms4,setter:()=>setDownAlarm1Modal(true)},
            {alarms:alarms5,setter:()=>setDownAlarm2Modal(true)},
            {alarms:alarms6,setter:()=>setDownAlarm3Modal(true)},
            {alarms:alarms7,setter:()=>setDownAlarm4Modal(true)},
          ].map(({alarms,setter},idx)=>(
            <Col lg={3} key={idx}>
              <div className="indicators">
                {editMode && (
                  <button className="btn btn-primary" style={{borderRadius:"6px",width:"28px",height:"28px",padding:"0",fontSize:"18px"}} onClick={setter}>
                    <i className="ri-add-line" />
                  </button>
                )}
                {alarms.map((item,i)=>(
                  <div key={i} className="indicator-row">
                    <span>{item.description}</span>
                    <span className="status-light green" />
                  </div>
                ))}
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );

  const widgets = [
    { id:"header",     label:"Ship Header",    icon:"mdi mdi-ferry",           defaultW:12, defaultH:3,  minH:3,  content: ShipHeader     },
    { id:"indicators", label:"Indicators",     icon:"mdi mdi-gauge",           defaultW:12, defaultH:7,  minH:5,  content: IndicatorsPanel },
    { id:"gauges",     label:"Gauges & Engine",icon:"mdi mdi-engine-outline",  defaultW:12, defaultH:10, minH:6,  content: GaugesPanel     },
    { id:"downalarms", label:"Down Alarms",    icon:"mdi mdi-alert-outline",   defaultW:12, defaultH:6,  minH:4,  content: DownAlarmsPanel },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Equipment List" />
          <PageGrid pageKey="equipment_list" widgets={widgets} />
        </Container>
      </div>

      <MachineModal isOpen={modal_list} toggle={()=>setmodal_list(false)} editedMachine={editedMachine}
        responseMessage={responseMessage} formData={formData} handleParamChange={handleParamChange}
        handleDeleteRow={handleDeleteRow} handleAddRow={handleAddRow} />
      <IndicatorsModal isOpen={indicatorsModal} toggle={()=>setIndicatorsModal(false)} initialData={indicatorsData} onSave={setIndicatorsData} />
      <GaugesModal isOpen={gaugesModal} toggle={()=>setGaugesModal(false)} initialData={gaugesData} onSave={setGaugesData} />
      <DownAlarm1Modal isOpen={downAlarm1Modal} toggle={()=>setDownAlarm1Modal(false)} initialData={downAlarm1Data} onSave={setDownAlarm1Data} />
      <DownAlarm2Modal isOpen={downAlarm2Modal} toggle={()=>setDownAlarm2Modal(false)} initialData={downAlarm2Data} onSave={setDownAlarm2Data} />
      <DownAlarm3Modal isOpen={downAlarm3Modal} toggle={()=>setDownAlarm3Modal(false)} initialData={downAlarm3Data} onSave={setDownAlarm3Data} />
      <DownAlarm4Modal isOpen={downAlarm4Modal} toggle={()=>setDownAlarm4Modal(false)} initialData={downAlarm4Data} onSave={setDownAlarm4Data} />
      {currentType && <ExhaustSection isOpen={true} toggle={closeModal} type={currentType} />}
    </React.Fragment>
  );
};

export default Machine;
